import { DataMainBoardSearchParams } from '../depreciation/types';
import { ApiValidationError } from '../error';

/**
 * ================================================
 * 基板番号別データのAPIリクエスト前のパラメータバリデーション
 * ================================================
 */

/**
 * 機種コード（kiList）の必須チェック
 */
const validateKiListRequired = (params: DataMainBoardSearchParams): void => {
  if (!params.kiList || params.kiList.length === 0) {
    throw new ApiValidationError(
      '機種コードが指定されていません',
      'kiList',
      'MISSING_KI_LIST'
    );
  }
};

/**
 * 日付ペアの整合性チェック
 * startDateがあればendDateも必須（逆も同様）
 */
const validateDatePair = (params: DataMainBoardSearchParams): void => {
  const hasStartDate = params.startDate != null && params.startDate !== '';
  const hasEndDate = params.endDate != null && params.endDate !== '';

  if (hasStartDate !== hasEndDate) {
    throw new ApiValidationError(
      'startDateとendDateは両方指定する必要があります',
      'datePair',
      'INVALID_DATE_PAIR'
    );
  }
};

/**
 * 日付の順序チェック
 * startDate が endDate より後の場合はエラー
 */
const validateDateOrder = (params: DataMainBoardSearchParams): void => {
  if (!params.startDate || !params.endDate) {
    return; // 日付が指定されていない場合はスキップ（ペアチェックで対応）
  }

  const start = new Date(params.startDate);
  const end = new Date(params.endDate);

  if (start > end) {
    throw new ApiValidationError(
      '開始日は終了日以前の日付を指定してください',
      'dateOrder',
      'INVALID_DATE_ORDER'
    );
  }
};

/**
 * 基板番号別データのパラメータバリデーション
 * APIリクエスト前に呼び出して不正なパラメータを検出する
 *
 * @param params チェック対象のパラメータオブジェクト
 */
export const validateDataMainBoardParams = (
  params: DataMainBoardSearchParams
): void => {
  // 1. 機種コードの必須チェック
  validateKiListRequired(params);

  // 2. 日付ペアの整合性チェック
  validateDatePair(params);

  // 3. 日付の順序チェック
  validateDateOrder(params);
};
